import {createSlice} from "@reduxjs/toolkit";
import {getUserVenues} from "@/store/user-info/action";

const initialState = {
  state: {
    venues: []
  },
  loading: true,
  error: ''
} as BaseState<UserInfoState>

const slice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // getUserVenues
    builder.addCase(getUserVenues.pending, (state) => ({
        ...state,
        loading: true
      }))
    builder.addCase(getUserVenues.fulfilled, (state, action) => ({
      state: {
        venues: action.payload
      },
      error: null,
      loading: false
    }))
    builder.addCase(getUserVenues.rejected, (state) => ({
        ...state,
        loading: true,
        error: 'Failed to get invoices'
      }))
  }
})

export default slice
